import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardLayout from '@examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from '@examples/Navbars/DashboardNavbar';
import { TabBar } from '@components/TabBar';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';
import { IntegrationBackButton } from '../components/integration-back-button';
import { WebhookList } from '../components/webhook-list';
import { ApiTokenPanel } from '../components/api-token-panel';

type ApiTab = 'webhooks' | 'tokens';

/// Tela técnica: o que o CRM envia (webhooks) e o que outro sistema usa para entrar (chaves de API).
export const ApiIntegrations = () => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);
    const [searchParams, setSearchParams] = useSearchParams();

    const tab: ApiTab = searchParams.get('aba') === 'tokens' ? 'tokens' : 'webhooks';

    return (
        <DashboardLayout>
            <DashboardNavbar title={t('integracoes.apiEWebhooks')} />

            <Box sx={{ background: cc.pageBg, borderRadius: 3, p: 2 }}>
                <IntegrationBackButton />

                <TabBar
                    current={tab}
                    onChange={(value) => setSearchParams({ aba: value }, { replace: true })}
                    tabs={[
                        { value: 'webhooks', label: t('webhooks.titulo') },
                        { value: 'tokens', label: t('apiTokens.titulo') },
                    ]}
                />

                <Box sx={{ mt: 2 }}>
                    {tab === 'webhooks' ? <WebhookList /> : <ApiTokenPanel />}
                </Box>
            </Box>
        </DashboardLayout>
    );
};
